import apiMixin from "../../../mixins/apiMixin";

const BrandKonstrucktorWordBank = {
    namespaced: true,
    state: {
        wordsbank: [],
        new_word: null,
        new_word_randomgenerator: null,
        konstruktorName: null,
        konstruktSelector: [],
        SavedKonstrukt: [],
        existingWord: [],
    },
    mutations: {
        setWordsbank: function (state, payload) {
            state.wordsbank = payload;
        },
        setnewWord: function (state, payload) {
            state.new_word = payload;
        },
        setSavedKonstrukt: function (state, payload) {
            state.SavedKonstrukt = payload;
        },
        setExistingWord: function (state, payload) {
            state.existingWord = payload;
        },
        setkonstruktSelector:function(state, payload){
            state.konstruktSelector = payload;
        }
    },
    actions: {
        SaveWordsForUser: async function (state, payload) {
            return apiMixin.methods.SaveWordsForUser(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    return true;

                });
        },

        getSavedKonstruktor: async function (state, payload) {
            return apiMixin.methods.getSaveKonstrukt(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    state.commit('setSavedKonstrukt', response.data);
                    // console.log(response.data);
                    return true;

                });
        },
        getuserwordExist: function (state, payload) {
            return apiMixin.methods.userwordExist(payload).then(
                response => {

                    if (!response) {
                        return false;
                    }
                    var datax =[];
                    // var datay =[];
                    response.data.forEach(function (data) {

                        if(data['result'] !== null ){
                            datax.push(data['keyword'] + '|'+ data['job_type']);

                        }

                    });
                    state.commit('setExistingWord', datax);



                });
        },
    },
    getters: {},
}
export default BrandKonstrucktorWordBank